import styled from 'styled-components';
import { palette } from 'styled-theme';
import { WithDirection } from '@jjj/components';

export const Wrapper = WithDirection(styled.div`
  width: 100%;

  .ant-tabs-nav {
    border: none !important;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .editSectorPositionRemoveBtnWrapper {
    display: inline-block;
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '0' : '20px')};
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '20px' : '0')};
    padding-top: 40px;

    &__button {
      cursor: pointer;
      border: none;
      background-color: transparent;

      svg {
        color: ${palette('success', 0)};
        font-size: 20px;
      }
    }
  }

  .rowActions {
    margin-top: 39px;

    .isoIconWrapper {
      text-align: center;
    }
  }

  .ant-legacy-form-item-control {
    height: 40px;
    line-height: 30px;
  }

  .baseError {
    color: ${palette('error', 0)};
  }
`);

export const AddRateLabel = WithDirection(styled.span`
  padding-left: ${props => (props['data-rtl'] === 'rtl' ? '0' : '5px')};
  padding-right: ${props => (props['data-rtl'] === 'rtl' ? '5px' : '0')};
`);
